import { track } from '../../analytics/events';

export const desktopAnalytics = () => ({
  // INPUT EVENTS
  input: {
    month: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'dob-month',
        fieldLabel: 'Month',
      },
      formContext: {
        formName: 'AGE_VERIFICATION',
      },
    }),
    day: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'dob-day',
        fieldLabel: 'Day',
      },
      formContext: {
        formName: 'AGE_VERIFICATION',
      },
    }),
    year: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'dob-year',
        fieldLabel: 'Year',
      },
      formContext: {
        formName: 'AGE_VERIFICATION',
      },
    }),
  },

  // CLICK EVENTS
  click: {
    verifyCheckbox: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'Verify Age',
      },
      actionOutcome: `TOGGLE_${on ? 'ON' : 'OFF'}`,
    }),
    back: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Back',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'SUBMIT',
    }),
  },
});

export const mobileAnalytics = () => ({
  // INPUT EVENTS
  input: {
    month: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'dob-month',
        fieldLabel: 'Month',
      },
      formContext: {
        formName: 'AGE_VERIFICATION',
      },
    }),
    day: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'dob-day',
        fieldLabel: 'Day',
      },
      formContext: {
        formName: 'AGE_VERIFICATION',
      },
    }),
    year: () => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'dob-year',
        fieldLabel: 'Year',
      },
      formContext: {
        formName: 'AGE_VERIFICATION',
      },
    }),
  },

  // CLICK EVENTS
  click: {
    verifyCheckbox: (on) => track('ElementClicked', {
      webElement: {
        elementType: 'CHECKBOX',
        text: 'Verify Age',
      },
      actionOutcome: `TOGGLE_${on ? 'ON' : 'OFF'}`,
    }),
    back: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Back',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'SUBMIT',
    }),
  },
});
